import { Logger } from '@/lib/logging.mjs';

import { colleagueAvailabilityEvents } from '@/utils/eventTarget.ts';

const logger = new Logger('colleagueAvailabilitiesCache');

const availabilities = {};

const ONLINE_STATUSES = ['available', 'busy', 'do_not_disturb'];

export function get(colleagueUuid) {
  try {
    return availabilities[colleagueUuid];
  } catch (error) {
    logger.error(error);
  }
}

export function all() {
  return availabilities;
}

export function set(colleagueUuid, availabilityInformation) {
  const previousAvailability = availabilities[colleagueUuid]?.availability;

  availabilities[colleagueUuid] = availabilityInformation;
  colleagueAvailabilityEvents.dispatchEvent(new CustomEvent(`notify-${colleagueUuid}`));

  if (previousAvailability === 'offline' && ONLINE_STATUSES.includes(availabilityInformation.availability)) {
    colleagueAvailabilityEvents.dispatchEvent(new CustomEvent('colleagueNowOnline', { detail: { colleagueUuid } }));
  }
}
